import React, { useEffect, useState } from "react";
import styles from "./AutoComplete.module.css";
import Input from "../input/Input";
function AutoComplete(props) {
  const [text, setText] = useState("");
  const [listSearch, setListSearch] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [focusInput, setFocusInput] = useState(false);
  let list = props.list || [];
  let id = props.id || "";
  let style = props.style || {};

  useEffect(() => {
    if (id) {
      for (let index = 0; index < list.length; index += 1) {
        let data = list[index];
        if (data["id"] == id) {
          itemClick(data);
        }
      }
    }
  }, [id, list]);

  useEffect(() => {
    if (text !== "") {
      setListSearch(
        list
          .filter((item) => {
            return (item["name"] + item["id"]).includes(text);
          })
          .slice(0, 20)
      );
    } else {
      setListSearch(list.slice(0, 20));
      if (props.default_id) {
        props.default_id("");
      }
    }
  }, [text]);

  const itemClick = (item) => {
    // console.log("item click");
    props.callBack(item);
    setText(item["name"]);
    setTimeout(() => {
      setShowDetail(false);
    }, 100);
  };

  return (
    <div className={styles.container} style={style}>
      <Input
        label={props.label}
        disabledLabel={props.disabledLabel}
        placeholder={props.placeholder}
        value={text}
        setValue={setText}
        validate={text === "" ? true : false}
        onFocus={() => {
          setFocusInput(true);
        }}
        onBlur={() => {
          setTimeout(() => {
            setFocusInput(false);
          }, 150);
        }}
      />
      {focusInput ? (
        <div className={styles.list}>
          {listSearch.map((item, index) => {
            return (
              <>
                <div
                  key={index}
                  className={styles.item}
                  // onChange={() => { }}
                  onClick={() => {
                    itemClick(item);
                  }}
                >
                  <div className={styles.name}>{item.name}</div>
                  {item.detail ? (
                    <div className={styles.detail}>{item.detail}</div>
                  ) : null}
                </div>
              </>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}

export default AutoComplete;
